export default {
    //图表 红
    color1: "#ef7666",
    //图表蓝
    color2: "#72c0f7",
    //图表绿
    color3: "#b2d99a",
    //图表 粉
    color4: "#ffcccc",
    //图表 橙
    color5: "#f6c387",
    //图表 灰色
    color6: "#d3d3d3",
    //图表 深绿
    color7: "#66cc27",

}